export default __webpack_public_path__ + "static/media/poster-06.ede6757c.png";